export class RandomUniqueValueOptions {
    constructor(name: string) {
        this.name = name;
    }

    name: string;
    minValue?: number;
    maxValue: number = 999999;
    maxAttempts: number = 15;
    breakMaxToGetValue: boolean = false;
}